import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { getCurvePaletteColor } from '../../shared/curvePalette';
import styles from '../DirectionalDrillingMonitor.module.css';
import type { DirectionalDrillingState } from '../store/DirectionalDrillingState';
import type { ToolState } from '../store/ToolState';

const Label = observer(function Label({ toolState, theme }: { toolState: ToolState; theme: 'dark' | 'light' }) {
  const { t } = useTranslation('directionalDrillingWidget');
  return (
    <div className={styles.parameterContainer}>
      <div className={styles.topInfo} style={{ color: getCurvePaletteColor(theme, toolState.color) }}>
        <span>{toolState.toolName},</span>
        <span>{toolState.displayUnit}</span>
        {toolState.lastValue != null && <span className={styles.value}>{toolState.lastValue}</span>}
      </div>
      <div className={styles.bottomInfo}>
        {toolState.convertedNewPointGap != null && (
          <span>
            {toolState.convertedNewPointGap > 300 ? '>300' : toolState.convertedNewPointGap} {t('seconds')}{' '}
          </span>
        )}
        {toolState.convertedTimeGap != null && (
          <span>
            ({toolState.convertedTimeGap > 300 ? '>300' : toolState.convertedTimeGap} {t('seconds')})
          </span>
        )}
      </div>
    </div>
  );
});

export const ParameterLabels = observer(function ParameterLabels({
  widgetState,
}: {
  widgetState: DirectionalDrillingState;
}) {
  return (
    <div className={styles.labelsContainer}>
      {widgetState.gravityToolState?.isVisible && (
        <Label toolState={widgetState.gravityToolState} theme={widgetState.appParams.theme} />
      )}
      {widgetState.magneticToolState?.isVisible && (
        <Label toolState={widgetState.magneticToolState} theme={widgetState.appParams.theme} />
      )}
    </div>
  );
});
